import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router";

// element-ui
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// 引用字体
import '@/assets/fonts/SourceHanSansSC/sourcehansanssc-font.css';
// 引入全局样式
import '@/assets/scss/style.css'


let app = createApp(App)

app
	.use(router)
	.use(ElementPlus,{locale:zhCn})
	.mount('#app')
